jQuery(document).ready(function($) {
    console.log("share data");
    function loadShareDocs(page = 1) {

        let language = $("#filter-language").val();
        //console.log("language", language);
        //console.log("current_page_id", current_page_id);
        //console.log("share_per_page", share_per_page);
        if (typeof current_page_id !== "undefined" && current_page_id !== "" && typeof share_per_page !== "undefined" && share_per_page !== "") {
        $.ajax({
            url: localized_object.ajax_url,
            type: "POST",
            data: {
                action: "load_share_docs",
                page: page,
                page_id: current_page_id,
                language: language,
                per_page: share_per_page
            },
            beforeSend: function () {
                if ($("#share-table .loader-overlay").length === 0) {
                    $("#share-table").append("<div class='loader-overlay'><div class='spinner'></div></div>");
                }
            },
            success: function(response) {
                let data = JSON.parse(response);
                $("#share-table").html(data.html);
                $("#share-pagination").html(data.pagination);
            },
            complete: function() {
                $(".loader-overlay").remove();
            }
        });
     }
    }

    // load first page
    loadShareDocs(1);

    // pagination click
    $(document).on("click", ".fillings-page", function(e) {
        e.preventDefault();
        const nextPage = $(this).data("page");
        loadShareDocs(nextPage);
    });

    // re-load when filters change
    $("#filter-filing, #filter-language").on("change", function() {
        console.log("share data filte");
        loadShareDocs(1);
    });

});
